import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HourglassTwoToneSvg from "@ant-design/icons-svg/es/asn/HourglassTwoTone";
import AntdIcon from "../components/AntdIcon";
var HourglassTwoTone = function HourglassTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HourglassTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HourglassTwoTone.displayName = 'HourglassTwoTone';
}
export default /*#__PURE__*/React.forwardRef(HourglassTwoTone);